import React from 'react';
import PropType from 'prop-types';
import Mage from './Mage';
import Enemies from './Enemies';
import VideoOverlay from '../common/VideoOverlay';


export default class GamePlaySection extends React.Component {
    static propTypes = {
        content: PropType.object
    };
    state= {
        showOverlay: false
    };

    showVideo = () => {
        this.setState({showOverlay: !this.state.showOverlay});
    };

    closeOverlay = () => {
        const el = this.videoContainer.overlay;
        TweenMax.to(el, 0.3, {autoAlpha: 0, ease: Power1.easeOut, onComplete: this.hideOverlay});
    };

    hideOverlay = () => {
        this.setState({showOverlay: false});
    };

    render() {
        const {content} = this.props;
        const video = '6qr0-d3eDrc';
        return (
            <div ref={(c) => {this.wrapper = c;}} className="container-fluid game-play-section">
                <div className="background" />
                <div className="mountains" />
                <Enemies />
                <Mage />
                <div className="content-container">
                    <div className="content">
                        <h1>Your Battle Begins!</h1>
                        <div dangerouslySetInnerHTML={{__html: content.description}} />
                    </div>
                    <div className="btn-container">
                        <div role="presentation" className="btn" onClick={this.showVideo} />
                        <h6>Official Gameplay Trailer</h6>
                    </div>
                </div>
                {this.state.showOverlay ? (
                    <VideoOverlay
                        ref={(c) => {this.videoContainer = c;}}
                        video={video}
                        closeOverlay={this.closeOverlay}
                        showOverlay={this.state.showOverlay} />
                ) : null}
            </div>
        );
    }
}

